import styled from 'styled-components';

export const Container = styled.div`
  background-color: #f5f5f5;
  &&.titleContainer {
    display: flex;
    margin-top: 50px;
    margin-bottom: 10px;
  }
  .title {
    width: 180px;
    text-align: left;
    font-family: Roboto;
    letter-spacing: 0;
    color: #2b2727;
    opacity: 1;
    font-size: 24px;
  }
  .validationButton {
    float: right;
  }
`;

export const GlobalBloc = styled.div`
  &&.globalBloc {
    position: relative;
    margin-top: 150px;
  }
`;
